import type { ReminderDto } from '../../services/api';
import { t } from '../../services/i18n';
import { PROPERTY_ICONS, escapeHtml, formatDate } from './property-shared';

export class RcPropertyRemindersTab extends HTMLElement {
  reminders: ReminderDto[] = [];

  render(): void {
    this.innerHTML = `
      <div class="tab-toolbar">
        <button class="btn btn-primary btn-sm" data-action="add-reminder">${PROPERTY_ICONS.plus} ${t('reminder.add')}</button>
      </div>
      ${this.reminders.length === 0
        ? `<div class="empty-state"><p>${t('property.reminders.empty')}</p></div>`
        : `<table>
            <thead><tr><th>${t('common.title')}</th><th>${t('common.deadline')}</th><th>${t('common.status')}</th><th>${t('common.actions')}</th></tr></thead>
            <tbody>
              ${this.reminders.map((reminder) => {
                const overdue = !reminder.isCompleted && new Date(reminder.dueDate) < new Date();
                const soon = !reminder.isCompleted && !overdue && (new Date(reminder.dueDate).getTime() - Date.now()) < 7 * 86400000;
                let cls = 'badge-success'; let label = t('common.open');
                if (reminder.isCompleted) { cls = 'badge-muted'; label = t('common.completed'); }
                else if (overdue) { cls = 'badge-danger'; label = t('common.overdue'); }
                else if (soon) { cls = 'badge-warning'; label = t('common.soon'); }
                return `
                  <tr>
                    <td>${escapeHtml(reminder.title)}</td>
                    <td>${formatDate(reminder.dueDate)}</td>
                    <td><span class="badge ${cls}">${label}</span></td>
                    <td>
                      <div class="card-actions">
                        ${!reminder.isCompleted ? `<button class="btn btn-outline btn-sm" data-action="complete-reminder" data-id="${reminder.id}">${t('reminder.complete')}</button>` : ''}
                        <button class="btn btn-danger btn-sm" data-action="delete-reminder" data-id="${reminder.id}">${t('common.delete')}</button>
                      </div>
                    </td>
                  </tr>`;
              }).join('')}
            </tbody>
          </table>`}
    `;
  }
}

if (!customElements.get('rc-property-reminders-tab')) {
  customElements.define('rc-property-reminders-tab', RcPropertyRemindersTab);
}
